import { atom } from 'jotai'
import type { MediaAsset } from '../../ui'
import type { AssetHubSort } from './types'

export const assetHubOpenAtom = atom(false)

/**
 * Holds the resolve/reject pair for the current open() promise.
 * When an asset is selected, resolve is called. When closed without selection, resolve(undefined).
 * If a second caller opens while a previous promise is pending, the previous is rejected.
 */
export const assetHubPromiseAtom = atom<
	{
		resolve: (value: MediaAsset | undefined) => void
		reject: (reason?: unknown) => void
	} | null
>(null)

// Shared UI state — persists across open/close cycles and is read by both Picker and Page
export const assetHubSelectedAssetIdAtom = atom<string | null>(null)
export const assetHubCollectionFilterAtom = atom<string | null>(null)
export const assetHubSortAtom = atom<AssetHubSort>('date-desc')
export const assetHubSearchAtom = atom('')
